module.exports = __webpack_public_path__ + "img/Arrow_Up_Grey.e04c3231.svg";